import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment'

@Component({
  selector: 'app-live-class',
  templateUrl: './live-class.component.html',
  styleUrls: ['./live-class.component.css']
})
export class LiveClassComponent implements OnInit {

  Submitted:boolean = false;
  ClientID="5UjGL2diQJ2teUQEAqfgSw";
  ClientSecret="WnyE2v2tKaEf6Z8kHPgnNQOt8rkZ1kgs";
  
  code:any;
  apiKey="tvqkYyygRHm-LTDNuQGG_Q";
  apiSecret="2FS4v0Gjwr6zC5CRCm2awt2vrBQxI4PchJNl";
  meetingNumber:any; // always generate new when requested or user will input
  role = 1;
  //leaveUrl = this.globalHelper.WebUrl+"liveclass"; // Your redirect Url, when meeting over
  userName = this.globalHelper.GetLoginToken().FirstName;
  userEmail = '';
  meetingPassWord = ''; // set default meeting password here
  joinUrl="";
  posting:boolean= false;
  meetingCreated: boolean = false;
  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService,private _sanitizer: DomSanitizer) { }

  
    SearchModel = {    
      StaffID:0,
      ClassID:0,
      SectionID:0,
      CurrentIndex: 0,
      PageSize: 20,
   };
 
   ClearSearch(){
     this.SearchModel.ClassID=0;
     this.SearchModel.SectionID=0;
     this.SearchModel.StaffID=0;
     this.LiveClassList=[];
     this.pageSizes();
   }
   Content: '';
   
   LearningModel = {   
     LiveClassID:0,
     MeetingNo:"",
     MeetingPassWord:"",
     JoinUrl:"",
     LiveClassTypeID:0,
     ClassSectionID: "",
     ClassID:0,
     SectionID:0,
     StaffID:0,
     LiveClassHeading: '',
     ResourcePath: '',   
     IsActive: true,
     IsShared:false,
     StartTime:  moment(new Date()).format('DD-MMM-YYYY HH:mm'),
     StartDate:'',
     StartDateTime:'',   
     Duration:0,
     Password:""
    };
 
   Clear() {
     this.LearningModel.LiveClassID = 0;
     this.LearningModel.LiveClassTypeID = 0;
     this.LearningModel.StaffID = 0;
     this.LearningModel.ClassID = 0;
     this.LearningModel.SectionID = 0;
     this.LearningModel.ResourcePath = '';
     this.LearningModel.LiveClassHeading = '';
     this.LearningModel.ClassSectionID = '';
     this.Content = '';
     this.Submitted = false;
     this.LearningModel.Duration = 0;
     this.LearningModel.StartDateTime = '';
     this.LearningModel.StartTime = moment(new Date()).format('DD-MMM-YYYY HH:mm');
 }
 
 Edit(obj) {
   this.LearningModel.LiveClassID = obj.LiveClassID;
   this.LearningModel.ClassSectionID = obj.ClassSectionID;
   this.SetID();
   this.LearningModel.StaffID=obj.StaffID; 
   this.LearningModel.ResourcePath = obj.ResourcePath;
   this.LearningModel.LiveClassHeading = obj.LiveClassHeading;
   this.LearningModel.IsShared = obj.IsShared;
   this.LearningModel.Duration = obj.Duration;
   this.LearningModel.LiveClassTypeID = obj.LiveClassTypeID;
   this.LearningModel.MeetingNo = obj.MeetingNo;
   this.LearningModel.JoinUrl = obj.JoinUrl;
   this.LearningModel.MeetingPassWord = obj.MeetingPassWord;
   this.Content = obj.Description;
   this.LearningModel.IsActive = obj.IsActive;
   this.LearningModel.StartDate = obj.StartDateTime != null && obj.StartDateTime != '' ? moment(obj.StartDateTime).format('DD-MMM-YYYY') : '';
   this.LearningModel.StartTime = obj.StartDateTime != null && obj.StartDateTime != '' ? moment(obj.StartDateTime).format('DD-MMM-YYYY HH:mm') : '';
 
 }
 
 ValidityState(){
   return this.LearningModel.LiveClassTypeID==0|| this.LearningModel.StaffID==0||this.LearningModel.ClassID==0||this.LearningModel.SectionID==0||this.LearningModel.LiveClassHeading=='' ;
 }
 
 SaveLiveClass() {  
   this.Submitted = true;
   if (!this.ValidityState()) {
     this.LearningModel.StartDate = this.LearningModel.StartDate != null && this.LearningModel.StartDate != '' ? moment(this.LearningModel.StartDate).format('DD-MMM-YYYY') : '';
     this.LearningModel.StartTime = this.LearningModel.StartTime != null && this.LearningModel.StartTime != '' ? moment(this.LearningModel.StartTime).format('HH:mm') : '';
   
 if(this.LearningModel.LiveClassTypeID==1){
  
 
  const request = {
   
     MeetingRequest:
      {
        email:"singhaniya.radhe@gmail.com",
        topic: this.LearningModel.LiveClassHeading,
        duration:this.LearningModel.Duration,
        start_time: "",
        type:2,
        password: this.LearningModel.Password == "" || this.LearningModel.Password == undefined || this.LearningModel.Password == null ? this.meetingPassWord : this.LearningModel.Password,
        
      },
      StartDate:this.LearningModel.StartDate,
      StartTime:this.LearningModel.StartTime,
      MeetingNo:this.LearningModel.MeetingNo,
  };    
  this.learningservice.CreateNewMeeting(request).subscribe((data: any) => {
    if(this.LearningModel.MeetingNo==""||this.LearningModel.MeetingNo==null){
 
    
    this.meetingNumber = data.id;
    this.meetingPassWord = data.password;
    this.joinUrl = data.join_url;
    this.meetingCreated = true;
    this.LearningModel.MeetingNo=this.meetingNumber;
    this.LearningModel.MeetingPassWord=this.meetingPassWord;
    this.LearningModel.JoinUrl=this.joinUrl;
    }
    this.spinnerService.show();
    
   this.learningservice.SaveLiveClass(JSON.stringify(this.LearningModel),this.Content).subscribe((data: any) => {
     if (data.webResponse.Status) {
       this.GetAllLiveClass();
     }
     if (data.webResponse.Status && this.LearningModel.LiveClassID == 0) {
       this.Clear();
     }else{
       this.LearningModel.StartTime =moment(this.LearningModel.StartDateTime).format('DD-MMM-YYYY HH:mm');
     }
     this.globalHelper.CheckActionStatus(data);
     this.spinnerService.hide();
   });
  });
 
    
   }else{
     this.spinnerService.show();
     this.LearningModel.StartDate = this.LearningModel.StartDate != null && this.LearningModel.StartDate != '' ? moment(this.LearningModel.StartDate).format('DD-MMM-YYYY') : '';
       this.LearningModel.StartTime = this.LearningModel.StartTime != null && this.LearningModel.StartTime != '' ? moment(this.LearningModel.StartTime).format('HH:mm') : '';
      
    this.learningservice.SaveLiveClass(JSON.stringify(this.LearningModel),this.Content).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllLiveClass();
      }
      if (data.webResponse.Status && this.LearningModel.LiveClassID == 0) {
        this.Clear();
      }
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
 
   }
   }
 };
 LiveClassList=[];
 GetAllLiveClass() {
   this.spinnerService.show();
   this.SearchModel.CurrentIndex = this.currentPage;
   this.SearchModel.PageSize = this.pageSize;
   this.learningservice.GetAllLiveClass(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
     this.LiveClassList = data.LiveClassList;
     this.spinnerService.hide();
     this.globalHelper.CheckActionStatus(data);
     this.recordCount = 0;
     if (data.LiveClassList != null && data.LiveClassList.length > 0) {
         this.recordCount = data.LiveClassList[0].RecordCount;
     }
     this.numberOfPages();
   });
 };
 
 MarkActiveLiveClass(item) {
   this.LearningModel.LiveClassID = item.LiveClassID;
   this.LearningModel.IsActive = item.IsActive == true ? false : true;
   this.spinnerService.show();
   this.learningservice.MarkActiveLiveClass(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
     if (data.webResponse.Status) {
       if(item.LiveClassTypeID==1){
 
       
      
      
       const request = {
         
           MeetingNo:item.MeetingNo,
       };    
       this.learningservice.delete(request).subscribe((data: any) => {
          });
         }
       this.GetAllLiveClass();
     }
    
     this.globalHelper.CheckActionStatus(data);
     this.spinnerService.hide();
   });
 };

 MPGCode:any;
 
 joinMeeting(item) {
  this.LearningModel.LiveClassID = item.LiveClassID;  
  this.spinnerService.show();
  this.learningservice.CreateMeetingCode(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
    if (data.webResponse.Status) {
     this.MPGCode=data.MeetingDetails.MPGCode;
     var url = this.globalHelper.WebZoomUrl+"auth?MPGCode="+ this.MPGCode;
    
      this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
      
    }
   
   
    this.spinnerService.hide();
  });
};
ToDate=new Date(); 
StartDateTime:any;
GetStartDate(item){
 this.StartDateTime=new Date(item.StartDateTime);
 item.StartDateTime=new Date(this.StartDateTime);
 return  item.StartDateTime;
}
EndDateTime:any;
GetEndDate(item){
this.StartDateTime=new Date(item.StartDateTime);
item.EndDateTime=new Date(this.StartDateTime.getTime() + item.Duration*60000);
return  item.EndDateTime;
}
embedURL(url){
  return this._sanitizer.bypassSecurityTrustResourceUrl(url); 
 
}
  ngOnInit() {
    this.GetClass();
    this.GetSection();
    this.GetClassSection();   
    this.GetAllLiveClass();
  }
  ClassList=[];
  GetClass() {
    this.LookupService.GetLookupsList('LPClass', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  }
 
  ClassSectionList: any;
  GetClassSection() {
    this.LookupService.GetLookupsList('STClassSection', '').subscribe((data) => {
      this.ClassSectionList = data.LookupItems;
    
    });

  };
  SetID() {
    this.LearningModel.ClassID = 0;
    this.LearningModel.SectionID = 0;
    if (this.LearningModel.ClassSectionID != "") {
      var strClassSectionID = this.LearningModel.ClassSectionID.split('-');
      this.LearningModel.ClassID = parseInt(strClassSectionID[0]);
      this.LearningModel.SectionID = parseInt(strClassSectionID[1]);
      this.GetSubjectTeacher();
    }
  }
  SectionList=[];
  GetSection() {
    this.SearchModel.SectionID=0;
    var ItemBO={
     'ItemID':this.SearchModel.ClassID
   }
    this.LookupService.GetLookupsList('LPSection', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
    });
  }


  meet()
  {
    
  this.posting=true;
  }
  
  SubjectTeacherList=[];
  GetSubjectTeacher() {
    this.LearningModel.StaffID=0;
    var ItemBO={
     'ItemID':this.LearningModel.ClassID,
     'ItemID1':this.LearningModel.SectionID
   }
    this.LookupService.GetLookupsList('AllClassSubjectTeacher', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SubjectTeacherList = data.LookupItems;
    });
  }
 

  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
   this.totalPages = Math.ceil(this.recordCount / this.pageSize);
   }

   nextPage() {
   this.currentPage = this.currentPage + 1;
   }

   pageSizes() {
   this.currentPage = 1;
   this.recordCount = 0;
   this.totalPages = 0;
   }
 
}






